import { FC } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import {
  Container,
  Title,
  Documents,
} from 'components/JustificativeDocuments/style';
import messages from 'components/JustificativeDocuments/messages';
import { translate } from 'containers/services/translate';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { openDocument } from 'containers/UploadDocuments/utils';
import { BlobProvider } from '@react-pdf/renderer';
import DesignationLetter from 'components/DesignationLetter/DesignationLetter';
import { isTransactionMission } from 'containers/CourtManagerAssignedExpertise/utils';
import { DocumentType } from 'components/JustificativeDocuments/type';
import Document from 'components/Document';
import DesignationLetterTransaction from 'components/DesignationLetter/DesignationLetterTransaction';

export interface JustificativeDocumentsProps {
  intl: IntlShape;
  documents: DocumentType[];
  mission: any;
}

const JustificativeDocuments: FC<JustificativeDocumentsProps> = props => {
  const documents = props.documents || [];
  return (
    <Container>
      <Title>
        {translate({ ...messages.UploadDocumentsBlocRecapTitle }, props)}
      </Title>
      <Documents>
        {documents.map((doc: any) => (
          <Document
            name={doc?.name}
            type={doc?.type}
            icon={
              <VisibilityIcon
                className="consult"
                onClick={openDocument(doc?.url)}
              />
            }
          />
        ))}
        {(!isTransactionMission(props.mission) ||
          (isTransactionMission(props.mission) &&
            get(props.mission, 'generateAssignementLetter', false))) && (
          <Document
            name={translate(messages.designationLetter, props)}
            type={translate(messages.designationLetter, props)}
            icon={
              <BlobProvider
                document={
                  (isTransactionMission(props.mission) ? (
                    <DesignationLetterTransaction data={props.mission} />
                  ) : (
                    <DesignationLetter data={props.mission} />
                  )) as any
                }
              >
                {params => {
                  return (
                    <a
                      href={params.url ? params.url : ''}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <VisibilityIcon
                        style={{ color: 'black' }}
                        className="consult"
                      />
                    </a>
                  );
                }}
              </BlobProvider>
            }
          />
        )}
      </Documents>
    </Container>
  );
};

export default injectIntl(JustificativeDocuments);
